export enum TransformType {
  RECORD = 'record',
  ATTRIBUTE = 'attribute',
  CUSTOM = 'custom',
}

export interface TransformDataForm {
  name: string;
  documentation?: string;
  description?: string;
  transformType: TransformType;
  codeLanguage: string;
  code: string;
  txArgs: {
    v: number;
    items: {
      name: string;
      description: string;
    }[];
  };
  input: string;
  inputAttrs: string[];
  output: string;
  shouldInitFormData: boolean;
  testAttrTransformMessage?: string;
  txUpdateDone: boolean;
  txUpdateId?: string;
  txUpdateError?: string;
  txArgsTestData: {
    fName: string;
    type: string;
    value: any;
  }[];
}
